import { FC } from "react";
import { GenericSortedCell, SortedCellProps } from "../commons/table/cell/SortedCell";
import { SortingPlayerAgent } from "../../features/manage_players_agents/models/sorting";

export const SortedCellPlayersAgents: FC<SortedCellProps<SortingPlayerAgent>> = (props) => {
    return <GenericSortedCell {...props} />
}